import { FormattedMessage } from 'react-intl';
import React from 'react';
import style from './accountNotificationsTitle.module.scss';
import { AccountNotification } from 'acscp/api/models/accountNotification';
import { FormattedDate } from './formattedDate';

export const AccountNotificationTitle: React.FC<{notification: AccountNotification}> = ({ notification }) => {
    // There is a small chance that a given notification will not contain a route and flight date.
    // This can be caused by a notification being created before release 4.2 and then its booking
    // being unpublished. This means that the API cannot find the info from the booking (and does not have
    // it snapshotted. In this case we fall back to the old method of showing the enquiry number
    if (notification.route && notification.flightDate) {
        return (
            <div className={style.ItemTitle}>
                <span className={style.Route}>{notification.route}</span>
                <span className={style.FlightDate}><FormattedDate date={notification.flightDate} /></span>
            </div>
        );
    }

    return (
        <div className={style.ItemTitle}>
            <FormattedMessage
                id={'components.accountNotificationsPage.enquiryReference'}
                defaultMessage={'Enquiry number: {number}'}
                values={{number: notification.enquiryNumber}}
            />
        </div>
    );
};
